<app-loader *ngIf="isDisabled"></app-loader>

<nav>
    <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <button class="nav-link" [ngClass]="{'active': this.filter.activeid == 1}" id="nav-home-tab"
            data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home"
            aria-selected="true" (click)="activeTab(1)">Expense</button>
        <button class="nav-link" [ngClass]="{'active': this.filter.activeid == 2}" id="nav-profile-tab"
            data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile"
            aria-selected="false" (click)="activeTab(2)">Advance Expense</button>
    </div>
</nav>
<div class="tab-content" id="nav-tabContent">
    <div class="tab-pane fade" [ngClass]="{'active show': this.filter.activeid == 1}" id="nav-Expense" role="tabpanel"
        aria-labelledby="nav-expense-tab">
        <div class="card mx-1">
            <div class="card-header">
                <div class="row">
                    <div class="col">
                        Expense
                    </div>
                    <div class="col-auto">

                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4">
                        <label for="TravelTypeID" class="text-label-dark">Travel Type</label>
                        <ng-select name="TravelTypeID" placeholder="Select Travel Type"
                            [(ngModel)]="Expense.TravelTypeID">
                            <ng-option value=1>Local Trip</ng-option>
                            <ng-option value=2>Out Station</ng-option>
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select travel type
                        </div>
                    </div>
                    <div class="col-md-4" *ngIf="Expense.TravelTypeID == 2">
                        <label for="TravelTypeID" class="text-label-dark" style="width: 100%;">
                            Trip
                        </label>
                        <ng-select name="TravelTypeID" placeholder="Select Trip" [(ngModel)]="Expense.AdvanceExpenseID">
                            <ng-option *ngFor="let Trip of TripData" [value]="Trip.TripID">{{Trip.TripName}}</ng-option>
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select travel type
                        </div>
                    </div>
                    <div class="col-auto mt-4 pt-1"  *ngIf="Expense.TravelTypeID == 2"><button type="button" class="btn btn-outline-primary btn-sm"
                            (click)="AddTrip()"><span>+
                                Add</span></button></div>
                    <div class="col"></div>
                    <div class="col-auto mt-4  pt-1"><button type="button" class="btn btn btn-outline-primary btn-sm"
                            (click)="addItem()" [disabled]="isDisabled"><i class="bi bi-plus" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Add Item':'Loading...'}}</button></div>
                    <!-- <div class="col-md-4">
                        <label for="TripName" class="text-label-dark">Trip Name</label>
                        <input type="text" class="form-control" placeholder="Ex. Mumbai" id="TripName" name="TripName"
                            [(ngModel)]="Expense.TripName" #TripName="ngModel" maxlength="100">
                        <div class="invalid-feedback">
                            Please enter trip name
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label for="ExpenseDate" class="text-label-dark">Expense Date</label>
                        <div class="input-group">
                            <input class="form-control" placeholder="DD MMM YYYY" name="ExpenseDate"
                                [(ngModel)]="Expense.ExpenseDate" ngbDatepicker #ExpenseDate="ngbDatepicker" />
                            <button class="btn btn-outline-secondary bi bi-calendar3"
                                (click)="ExpenseDate.toggle()" type="button"></button>
                        </div>
                    </div> -->
                    <!-- <div class="col-md-4">
                        <label for="ExpenseCategoryID" class="text-label-dark">Expense Category</label>
                        <ng-select name="ExpenseCategoryID" placeholder="Select Expense Category"
                            [(ngModel)]="Expense.ExpenseCategoryID">
                            <ng-option value=1>Expense Category 1</ng-option>
                            <ng-option value=2>Expense Category 2</ng-option>
                        </ng-select>
                        <div class="invalid-feedback">
                            Please select expense category
                        </div>
                    </div> -->
                </div>
                <div class="row">
                    <div class="col-md-8">
                        <div class="row">
                            <!-- <div class="col-md-6">
                                <label for="KMs" class="text-label-dark">KMs</label>
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="Ex. 15" name="KMs"
                                        [(ngModel)]="Expense.KMs" #KMs="ngModel" maxlength="5" pattern="^[0-9.]*$"
                                        (keypress)="common.NumberOnly($event,common.allowDot(Expense.KMs))"
                                        (keyup)="common.NumberOnly($event,common.allowDot(Expense.KMs))">
                                    <span class="input-group-text" id="basic-addon2">KM</span>
                                </div>
                                <div class="invalid-feedback">
                                    Please enter KMs.
                                </div>
                            </div> -->
                            <!-- <div class="col-md-6">
                                <label for="ExpenseDate" class="text-label-dark">Expense Date</label>
                                <div class="input-group">
                                    <input class="form-control" placeholder="DD MMM YYYY" name="ExpenseDate"
                                        [(ngModel)]="Expense.ExpenseDate" ngbDatepicker #ExpenseDate="ngbDatepicker" />
                                    <button class="btn btn-outline-secondary bi bi-calendar3"
                                        (click)="ExpenseDate.toggle()" type="button"></button>
                                </div>
                            </div> -->
                            <!-- <div class="col-md-6">
                                <label for="TripName" class="text-label-dark">Trip Name</label>
                                <input type="text" class="form-control" placeholder="Ex. Mumbai" id="TripName"
                                    name="TripName" [(ngModel)]="Expense.TripName" #TripName="ngModel" maxlength="100">
                                <div class="invalid-feedback">
                                    Please enter trip name
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="ExpenseDate" class="text-label-dark">Expense Date</label>
                                <div class="input-group">
                                    <input class="form-control" placeholder="DD MMM YYYY" name="ExpenseDate"
                                        [(ngModel)]="Expense.ExpenseDate" ngbDatepicker #ExpenseDate="ngbDatepicker" />
                                    <button class="btn btn-outline-secondary bi bi-calendar3"
                                        (click)="ExpenseDate.toggle()" type="button"></button>
                                </div>
                            </div> -->
                        </div>
                        <div class="row">
                            <!-- <div class="col-md-6">
                                <label for="Merchant" class="text-label-dark">Merchant</label>
                                <input type="text" class="form-control" placeholder="Ex. Maxus" id="Merchant"
                                    name="Merchant" [(ngModel)]="Expense.Merchant" #Merchant="ngModel" maxlength="100">
                                <div class="invalid-feedback">
                                    Please enter merchant name
                                </div>
                            </div> -->
                            <!-- <div class="col-md-6">
                                <label for="ExpenseAmount" class="text-label-dark">Expense Amount</label>
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="Ex. 15000" name="ExpenseAmount"
                                        [(ngModel)]="Expense.ExpenseAmount" #ExpenseAmount="ngModel" maxlength="5"
                                        pattern="^[0-9.]*$"
                                        (keypress)="common.NumberOnly($event,common.allowDot(Expense.ExpenseAmount))"
                                        (keyup)="common.NumberOnly($event,common.allowDot(Expense.ExpenseAmount))">
                                    <span class="input-group-text" id="basic-addon2">INR</span>
                                </div>
                                <div class="invalid-feedback">
                                    Please enter expense amount.
                                </div>
                            </div> -->
                        </div>
                        <div class="row">
                            <!-- <div class="col-md-6">
                                <label for="Attachment" class="text-label-dark">Attachment</label>
                                <Input id="Attachment" name="Attachment" accept=".jpeg,.jpg,.png,.pdf" type="file"
                                    #Attachment required matTooltip="Choose File" matTooltipClass="tooltip" />
                            </div> -->
                        </div>
                    </div>
                    <div class="col-md-4">
                        <!-- <label for="Description" class="text-label-dark">Description</label>
                        <textarea type="text" class="form-control" placeholder="Ex. 100 Main ST" id="Description"
                            name="Description" [(ngModel)]="Expense.Description" #Description="ngModel" maxlength="200"
                            style="height: 100px;"></textarea>
                        <div class="invalid-feedback">
                            Please enter description!
                        </div> -->
                    </div>
                </div>
            </div>
            <!-- <div class="card border-radius-0 m-1 p-0">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Adavance Expense Item</div>
                        <div class="col-auto">
                            <div class="form-check form-switch" (click)="Advance = !Advance">
                                <input class="form-check-input toggle" type="checkbox" role="switch" [ngModel]="Advance"
                                    (change)="$event.preventDefault();">
                                <label class="form-check-label" [ngClass]="{'toggle-on':Advance,'toggle-off':!Advance}"
                                    for="flexSwitchCheckDefault">{{Advance?'ON':'OFF'}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0" #collapse="ngbCollapse" [(ngbCollapse)]="!Advance">
                    <table datatable class="table table-bordered overflow-auto d-table">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Category</th>
                                <th scope="col">Description</th>
                                <th scope="col">Rate</th>
                                <th scope="col">KMs</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Merchant</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let Items of AdvanceExpense.Items; let i = index">
                                <th scope="row" style="align-content: center;">{{i + 1}}</th>
                                <td><ng-select name="ExpenseCategoryID{{i}}" placeholder="Category"
                                        [(ngModel)]="Items.ExpenseCategoryID" style="width: 11rem;">
                                        <ng-option value=1>Expense Category 1</ng-option>
                                        <ng-option value=2>Expense Category 2</ng-option>
                                    </ng-select></td>
                                <td><textarea type="text" class="form-control" placeholder="Ex. 100 Main ST"
                                        id="Description{{i}}" name="Description{{i}}" [(ngModel)]="Items.Description"
                                        #Description="ngModel" maxlength="200"
                                        style="height: 38px;width: 17rem;"></textarea></td>
                                <td><input type="text" class="form-control" placeholder="Ex. 100" name="Rate{{i}}"
                                        [(ngModel)]="Items.Rate" #Rate="ngModel" maxlength="5" pattern="^[0-9.]*$"
                                        (keypress)="common.NumberOnly($event,common.allowDot(Items.Rate))"
                                        (keyup)="common.NumberOnly($event,common.allowDot(Items.Rate))"
                                        style="width: 6rem;"></td>
                                <td><input type="text" class="form-control" placeholder="Ex. 5" name="KMs{{i}}"
                                        [(ngModel)]="Items.KMs" #KMs="ngModel" maxlength="5" pattern="^[0-9.]*$"
                                        (keypress)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                        (keyup)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                        style="width: 6rem;"></td>
                                <td><input type="text" class="form-control" placeholder="Ex. 15000"
                                        name="ExpenseAmount{{i}}" [(ngModel)]="Items.ExpenseAmount"
                                        #ExpenseAmount="ngModel" maxlength="7" pattern="^[0-9.]*$"
                                        (keypress)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                        (keyup)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                        style="width: 8rem;"></td>
                                <td><input type="text" class="form-control" placeholder="Ex. Maxus" id="Merchant{{i}}"
                                        name="Merchant{{i}}" [(ngModel)]="Items.Merchant" #Merchant="ngModel"
                                        maxlength="100" style="width: 16rem;"></td>
                                <td style="align-content: center;text-align: center;"><i class="bi bi-trash deleteIcon"
                                        (click)="DeleteItem(i)"></i></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> -->
            <!-- <div class="row" *ngIf="Expense.TravelTypeID == 2 && Expense.AdvanceExpenseID != null">
                <div class="col-md-6 pe-1">
                    <div class="card border-radius-0 m-1 p-0">
                        <div class="card-header">
                            Advance Item
                        </div>
                        <div class="card-body p-0 mt-2 overflow-auto" (scroll)="updateScrollOne()" #scrollOne>
                            <table datatable class="table table-bordered overflow-auto d-table">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Category</th>
                                        <th scope="col">Description</th>
                                        <th scope="col">Rate</th>
                                        <th scope="col">KMs</th>
                                        <th scope="col">Amount</th>
                                        <th scope="col">Merchant</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let Items of AdvanceExpense.Items; let i = index">
                                        <th scope="row" style="align-content: center;">{{i + 1}}</th>
                                        <td><ng-select name="ExpenseCategoryID{{i}}" placeholder="Category"
                                                [(ngModel)]="Items.ExpenseCategoryID" style="width: 11rem;">
                                                <ng-option value=1>Expense Category 1</ng-option>
                                                <ng-option value=2>Expense Category 2</ng-option>
                                            </ng-select></td>
                                        <td><textarea type="text" class="form-control" placeholder="Ex. 100 Main ST"
                                                id="Description{{i}}" name="Description{{i}}"
                                                [(ngModel)]="Items.Description" #Description="ngModel" maxlength="200"
                                                style="height: 38px;width: 17rem;"></textarea></td>
                                        <td><input type="text" class="form-control" placeholder="Ex. 100" name="Rate{{i}}"
                                                [(ngModel)]="Items.Rate" #Rate="ngModel" maxlength="5" pattern="^[0-9.]*$"
                                                (keypress)="common.NumberOnly($event,common.allowDot(Items.Rate))"
                                                (keyup)="common.NumberOnly($event,common.allowDot(Items.Rate))"
                                                style="width: 6rem;"></td>
                                        <td><input type="text" class="form-control" placeholder="Ex. 5" name="KMs{{i}}"
                                                [(ngModel)]="Items.KMs" #KMs="ngModel" maxlength="5" pattern="^[0-9.]*$"
                                                (keypress)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                                (keyup)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                                style="width: 6rem;"></td>
                                        <td><input type="text" class="form-control" placeholder="Ex. 15000"
                                                name="ExpenseAmount{{i}}" [(ngModel)]="Items.ExpenseAmount"
                                                #ExpenseAmount="ngModel" maxlength="7" pattern="^[0-9.]*$"
                                                (keypress)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                                (keyup)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                                style="width: 8rem;"></td>
                                        <td><input type="text" class="form-control" placeholder="Ex. Maxus"
                                                id="Merchant{{i}}" name="Merchant{{i}}" [(ngModel)]="Items.Merchant"
                                                #Merchant="ngModel" maxlength="100" style="width: 16rem;"></td>
                                        <td style="align-content: center;text-align: center;"><i
                                                class="bi bi-trash deleteIcon" (click)="DeleteItem(i)"></i></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 ps-1">
                    <div class="card border-radius-0 m-1 p-0">
                        <div class="card-header">
                            Advance Item
                        </div>
                        <div class="card-body p-0 mt-2 overflow-auto" (scroll)="updateScrolltwo()" #scrollTwo>
                            <table datatable class="table table-bordered overflow-auto d-table">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Category</th>
                                        <th scope="col">Description</th>
                                        <th scope="col">Rate</th>
                                        <th scope="col">KMs</th>
                                        <th scope="col">Amount</th>
                                        <th scope="col">Merchant</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let Items of AdvanceExpense.Items; let i = index">
                                        <th scope="row" style="align-content: center;">{{i + 1}}</th>
                                        <td><ng-select name="ExpenseCategoryID{{i}}" placeholder="Category"
                                                [(ngModel)]="Items.ExpenseCategoryID" style="width: 11rem;">
                                                <ng-option value=1>Expense Category 1</ng-option>
                                                <ng-option value=2>Expense Category 2</ng-option>
                                            </ng-select></td>
                                        <td><textarea type="text" class="form-control" placeholder="Ex. 100 Main ST"
                                                id="Description{{i}}" name="Description{{i}}"
                                                [(ngModel)]="Items.Description" #Description="ngModel" maxlength="200"
                                                style="height: 38px;width: 17rem;"></textarea></td>
                                        <td><input type="text" class="form-control" placeholder="Ex. 100" name="Rate{{i}}"
                                                [(ngModel)]="Items.Rate" #Rate="ngModel" maxlength="5" pattern="^[0-9.]*$"
                                                (keypress)="common.NumberOnly($event,common.allowDot(Items.Rate))"
                                                (keyup)="common.NumberOnly($event,common.allowDot(Items.Rate))"
                                                style="width: 6rem;"></td>
                                        <td><input type="text" class="form-control" placeholder="Ex. 5" name="KMs{{i}}"
                                                [(ngModel)]="Items.KMs" #KMs="ngModel" maxlength="5" pattern="^[0-9.]*$"
                                                (keypress)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                                (keyup)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                                style="width: 6rem;"></td>
                                        <td><input type="text" class="form-control" placeholder="Ex. 15000"
                                                name="ExpenseAmount{{i}}" [(ngModel)]="Items.ExpenseAmount"
                                                #ExpenseAmount="ngModel" maxlength="7" pattern="^[0-9.]*$"
                                                (keypress)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                                (keyup)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                                style="width: 8rem;"></td>
                                        <td><input type="text" class="form-control" placeholder="Ex. Maxus"
                                                id="Merchant{{i}}" name="Merchant{{i}}" [(ngModel)]="Items.Merchant"
                                                #Merchant="ngModel" maxlength="100" style="width: 16rem;"></td>
                                        <td style="align-content: center;text-align: center;"><i
                                                class="bi bi-trash deleteIcon" (click)="DeleteItem(i)"></i></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="card-body p-0 mt-2 overflow-auto">
                <table datatable class="table table-bordered overflow-auto d-table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Category</th>
                            <th scope="col">Description</th>
                            <th scope="col">Rate</th>
                            <th scope="col">KMs</th>
                            <th scope="col">Amount</th>
                            <th scope="col">Merchant</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let Items of AdvanceExpense.Items; let i = index">
                            <th scope="row" style="align-content: center;">{{i + 1}}</th>
                            <td><ng-select name="ExpenseCategoryID{{i}}" placeholder="Category"
                                    [(ngModel)]="Items.ExpenseCategoryID" style="width: 11rem;">
                                    <ng-option value=1>Expense Category 1</ng-option>
                                    <ng-option value=2>Expense Category 2</ng-option>
                                </ng-select></td>
                            <td><textarea type="text" class="form-control" placeholder="Ex. 100 Main ST"
                                    id="Description{{i}}" name="Description{{i}}" [(ngModel)]="Items.Description"
                                    #Description="ngModel" maxlength="200"
                                    style="height: 38px;width: 17rem;"></textarea></td>
                            <td><input type="text" class="form-control" placeholder="Ex. 100" name="Rate{{i}}"
                                    [(ngModel)]="Items.Rate" #Rate="ngModel" maxlength="5" pattern="^[0-9.]*$"
                                    (keypress)="common.NumberOnly($event,common.allowDot(Items.Rate))"
                                    (keyup)="common.NumberOnly($event,common.allowDot(Items.Rate))"
                                    style="width: 6rem;"></td>
                            <td><input type="text" class="form-control" placeholder="Ex. 5" name="KMs{{i}}"
                                    [(ngModel)]="Items.KMs" #KMs="ngModel" maxlength="5" pattern="^[0-9.]*$"
                                    (keypress)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                    (keyup)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                    style="width: 6rem;"></td>
                            <td><input type="text" class="form-control" placeholder="Ex. 15000"
                                    name="ExpenseAmount{{i}}" [(ngModel)]="Items.ExpenseAmount" #ExpenseAmount="ngModel"
                                    maxlength="7" pattern="^[0-9.]*$"
                                    (keypress)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                    (keyup)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                    style="width: 8rem;"></td>
                            <td><input type="text" class="form-control" placeholder="Ex. Maxus" id="Merchant{{i}}"
                                    name="Merchant{{i}}" [(ngModel)]="Items.Merchant" #Merchant="ngModel"
                                    maxlength="100" style="width: 16rem;"></td>
                            <td style="align-content: center;text-align: center;"><i class="bi bi-trash deleteIcon"
                                    (click)="DeleteItem(i)"></i></td>
                        </tr>
                    </tbody>
                </table>
            </div> -->
            <div class="card-body p-0 mt-2 overflow-auto">
                <table datatable class="customeDatatable table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Category</th>
                            <th scope="col">Description</th>
                            <th scope="col">Amount</th>
                            <th scope="col">ProjectedAmount</th>
                            <th scope="col">Diff Amount</th>
                            <th scope="col">Rate</th>
                            <th scope="col">KMs</th>
                            <th scope="col">Merchant</th>
                            <th scope="col">Date</th>
                            <th scope="col">Attachment</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let Items of AdvanceExpense.ItemsNew; let i = index">
                            <th scope="row" style="align-content: center;">{{i + 1}}</th>
                            <td>{{Items.ExpenseCategory}}</td>
                            <td>{{Items.Description}}</td>
                            <td class="text-end">{{Items.ExpenseAmount}}</td>
                            <td class="text-end">{{Items.ProjectedAmount}}</td>
                            <td  class="text-end" [ngClass]="{'text-danger':(Items.ProjectedAmount - Items.ExpenseAmount) < 0,'text-success':(Items.ProjectedAmount - Items.ExpenseAmount) >= 0}">{{Items.ProjectedAmount - Items.ExpenseAmount}}</td>
                            <td class="text-end">{{Items.Rate}}</td>
                            <td class="text-end">{{Items.KMs}}</td>
                            <td>{{Items.Merchant}}</td>
                            <td>{{Items.Date}}</td>
                            <td style="align-content: center;text-align: center;"><i class="bi bi-paperclip"></i></td>
                            <td style="align-content: center;text-align: center;"><i class="bi bi-trash deleteIcon"
                                    (click)="DeleteItem(i)"></i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-auto">
                        <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i
                                class="bi bi-chevron-right" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Submit':'Loading...'}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="tab-pane fade" [ngClass]="{'active show': this.filter.activeid == 2}" id="nav-AdvanceExpense"
        role="tabpanel" aria-labelledby="nav-profile-tab">
        <div class="card mx-1">
            <div class="card-header">
                <div class="row">
                    <div class="col">
                        Advance Expense
                    </div>
                    <div class="col-auto">
                        <button type="button" class="btn btn btn-outline-primary btn-sm" (click)="addItem()"
                            [disabled]="isDisabled"><i class="bi bi-plus" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Add Item':'Loading...'}}</button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-8">
                        <div class="row">
                            <div class="col-md-6">
                                <label for="TripName" class="text-label-dark">Trip Name</label>
                                <input type="text" class="form-control" placeholder="Ex. Mumbai" id="TripName"
                                    name="TripName" [(ngModel)]="AdvanceExpense.TripName" #TripName="ngModel"
                                    maxlength="100">
                                <div class="invalid-feedback">
                                    Please enter trip name
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="AdvanceAmount" class="text-label-dark">Advance Amount</label>
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="Ex. 15000" name="AdvanceAmount"
                                        [(ngModel)]="AdvanceExpense.AdvanceAmount" #AdvanceAmount="ngModel"
                                        maxlength="5" pattern="^[0-9.]*$"
                                        (keypress)="common.NumberOnly($event,common.allowDot(AdvanceExpense.AdvanceAmount))"
                                        (keyup)="common.NumberOnly($event,common.allowDot(AdvanceExpense.AdvanceAmount))">
                                    <span class="input-group-text" id="basic-addon2">INR</span>
                                </div>
                                <div class="invalid-feedback">
                                    Please enter advance amount.
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label for="FromDate" class="text-label-dark">From Date</label>
                                <div class="input-group">
                                    <input class="form-control" placeholder="DD MMM YYYY" name="FromDate"
                                        [(ngModel)]="AdvanceExpense.FromDate" ngbDatepicker #FromDate="ngbDatepicker" />
                                    <button class="btn btn-outline-secondary bi bi-calendar3"
                                        (click)="FromDate.toggle()" type="button"></button>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="ToDate" class="text-label-dark">To Date</label>
                                <div class="input-group">
                                    <input class="form-control" placeholder="DD MMM YYYY" name="ToDate"
                                        [(ngModel)]="AdvanceExpense.ToDate" ngbDatepicker #ToDate="ngbDatepicker" />
                                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDate.toggle()"
                                        type="button"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label for="Description" class="text-label-dark">Description</label>
                        <textarea type="text" class="form-control" placeholder="Ex. 100 Main ST" id="Description"
                            name="Description" [(ngModel)]="AdvanceExpense.Description" #Description="ngModel"
                            maxlength="200" style="height: 100px;"></textarea>
                        <div class="invalid-feedback">
                            Please enter description!
                        </div>
                    </div>
                </div>

                <div class="card-body p-0 mt-2 overflow-auto">
                    <table datatable class="customeDatatable table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Category</th>
                                <th scope="col">Description</th>
                                <th scope="col">Rate</th>
                                <th scope="col">KMs</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Merchant</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let Items of AdvanceExpense.Items; let i = index">
                                <th scope="row" style="align-content: center;">{{i + 1}}</th>
                                <td><ng-select name="ExpenseCategoryID{{i}}" placeholder="Category"
                                        [(ngModel)]="Items.ExpenseCategoryID" style="width: 11rem;">
                                        <ng-option value=1>Expense Category 1</ng-option>
                                        <ng-option value=2>Expense Category 2</ng-option>
                                    </ng-select></td>
                                <td><textarea type="text" class="form-control" placeholder="Ex. 100 Main ST"
                                        id="Description{{i}}" name="Description{{i}}" [(ngModel)]="Items.Description"
                                        #Description="ngModel" maxlength="200"
                                        style="height: 38px;width: 17rem;"></textarea></td>
                                <td><input type="text" class="form-control" placeholder="Ex. 100" name="Rate{{i}}"
                                        [(ngModel)]="Items.Rate" #Rate="ngModel" maxlength="5" pattern="^[0-9.]*$"
                                        (keypress)="common.NumberOnly($event,common.allowDot(Items.Rate))"
                                        (keyup)="common.NumberOnly($event,common.allowDot(Items.Rate))"
                                        style="width: 6rem;"></td>
                                <td><input type="text" class="form-control" placeholder="Ex. 5" name="KMs{{i}}"
                                        [(ngModel)]="Items.KMs" #KMs="ngModel" maxlength="5" pattern="^[0-9.]*$"
                                        (keypress)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                        (keyup)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                        style="width: 6rem;"></td>
                                <td><input type="text" class="form-control" placeholder="Ex. 15000"
                                        name="ExpenseAmount{{i}}" [(ngModel)]="Items.ExpenseAmount"
                                        #ExpenseAmount="ngModel" maxlength="7" pattern="^[0-9.]*$"
                                        (keypress)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                        (keyup)="common.NumberOnly($event,common.allowDot(Items.ExpenseAmount))"
                                        style="width: 8rem;"></td>
                                <td><input type="text" class="form-control" placeholder="Ex. Maxus" id="Merchant{{i}}"
                                        name="Merchant{{i}}" [(ngModel)]="Items.Merchant" #Merchant="ngModel"
                                        maxlength="100" style="width: 16rem;"></td>
                                <td style="align-content: center;text-align: center;"><i class="bi bi-trash deleteIcon"
                                        (click)="DeleteItem(i)"></i></td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- <div class="row">
                        <div *ngFor="let Items of AdvanceExpense.Items; let i = index">
                            <hr />
                            <div class="row mt-1">
                                <div class="col text-label-dark">
                                    Items - {{i + 1}}
                                </div>
                                <div class="col-auto">
                                    <i class="bi bi-trash deleteIcon" (click)="DeleteItem(i)"></i>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label for="ExpenseCategoryID{{i}}" class="text-label-dark">Expense
                                                Category</label>
                                            <ng-select name="ExpenseCategoryID{{i}}"
                                                placeholder="Select Expense Category"
                                                [(ngModel)]="Items.ExpenseCategoryID">
                                                <ng-option value=1>Expense Category 1</ng-option>
                                                <ng-option value=2>Expense Category 2</ng-option>
                                            </ng-select>
                                            <div class="invalid-feedback">
                                                Please select expense category
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <label for="Merchant{{i}}" class="text-label-dark">Merchant</label>
                                            <input type="text" class="form-control" placeholder="Ex. Maxus"
                                                id="Merchant{{i}}" name="Merchant{{i}}" [(ngModel)]="Items.Merchant"
                                                #Merchant="ngModel" maxlength="100">
                                            <div class="invalid-feedback">
                                                Please enter merchant name
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label for="ExpenseAmount{{i}}" class="text-label-dark">Expense
                                                Amount</label>
                                            <div class="input-group">
                                                <input type="text" class="form-control" placeholder="Ex. 15000"
                                                    name="ExpenseAmount{{i}}" [(ngModel)]="Items.ExpenseAmount"
                                                    #ExpenseAmount="ngModel" maxlength="5" pattern="^[0-9.]*$"
                                                    (keypress)="common.NumberOnly($event,common.allowDot(Expense.ExpenseAmount))"
                                                    (keyup)="common.NumberOnly($event,common.allowDot(Expense.ExpenseAmount))">
                                                <span class="input-group-text" id="basic-addon2">INR</span>
                                            </div>
                                            <div class="invalid-feedback">
                                                Please enter expense amount.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label for="Description{{i}}" class="text-label-dark">Description</label>
                                    <textarea type="text" class="form-control" placeholder="Ex. 100 Main ST"
                                        id="Description{{i}}" name="Description{{i}}" [(ngModel)]="Items.Description"
                                        #Description="ngModel" maxlength="200" style="height: 130px;"></textarea>
                                    <div class="invalid-feedback">
                                        Please enter description!
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="card-footer">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-auto">
                        <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i
                                class="bi bi-chevron-right" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Submit':'Loading...'}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>